import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';
import Skeleton from './skeleton';

// 去掉ssr主要是为了首页CLS过高问题
const ItemLineWithTabsMain = dynamic(() => import('./main'), {
  loading: Skeleton
});

const ItemLineWithTabs = props => {
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });

  const skeleton = <Skeleton />;

  if (props.data) {
    return <ItemLineWithTabsMain skeleton={skeleton} {...props} />;
  }

  if (!show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }

  return <ItemLineWithTabsMain skeleton={skeleton} {...props} />;
};

export default ItemLineWithTabs;
